import { Alert, Button, Card, Checkbox, Dropdown, Icon, Menu, Modal, Popover, Spin, Table } from 'antd';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import './MaintenanceCard.css';

import AirIcon from '../../../../../common/icons/AirIcon';
import leadsHelper from '../../../../../helpers/leadsHelper';

import { pick } from 'lodash';
import moment from 'moment';
import UpsertMaintenanceModal from '../../../../../common/components/UpsertMaintenanceModal';
import { api } from '../../../../../services';

@inject('translationsStore', 'commonStore')
@observer
export default class MaintenanceCard extends Component {
  constructor(props) {
    super(props);
    const { translationsStore, commonStore } = props;
    this.columns = [
      {
        dataIndex: 'description',
        title: translationsStore.translate('carView.MaintenanceCard.column.maintenance'),
        render: text => (
          <div title={text} className="maintenance-card-description">{text}</div>
        )
      },
      {
        dataIndex: 'km',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.scheduledKm'),
        render: text => <span>{text ? Number(text).toLocaleString() : '-'}</span>
      },
      {
        dataIndex: 'date',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.scheduledDate'),
        render: (text, record) => <span>{record.date ? moment(record.date).format(commonStore.longDateFormat.L) : '-'}</span>
      },
      {
        dataIndex: 'mileage',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.mileage'),
        render: text => <span>{text && text.toLocaleString()}</span>
      },
      {
        dataIndex: 'kmLeft',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.kmLeft'),
        render: (text, record) => <span>{record.mileage && record.km ? (record.km - record.mileage).toLocaleString() : <span>&mdash;</span>}</span>
      },
      {
        dataIndex: 'virtualDate',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.daysLeft'),
        render: (text, record) => (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', fontWeight: 'bold' }}>
            {!!record.virtualDate && <AirIcon type="tagliando" style={{ color: leadsHelper.maintenanceColor(moment().diff(moment(record.virtualDate, 'YYYY-MM-DD'), 'days')) }} />}
            {!!record.virtualDate && moment().diff(moment(record.virtualDate, 'YYYY-MM-DD'), 'days')}
          </div>
        )
      },
      {
        dataIndex: 'manage',
        align: 'right',
        render: (_, record) => {
          if(!record.id) {
            return null;
          }

          const onClick = ({key}) => {
            switch (key) {
              case "setMaintanance":
                this.setState({ showManageModal: true, selectedMaintenance: record.id });
                break;
              case "update":
                this.setState({ showModalUpsertInManage: true, selectedMaintenance: record });
                break;
              case "delete":
                this.setState({ showConfirmDelete: true, selectedMaintenance: record });
                break;
              default:
                break;
            }
          }

          const menu = (
            <Menu onClick={onClick} className="maintenance-dropdown-menu">
              <Menu.Item key="setMaintanance">
                <div className="MaintenanceCard__additionalcta_content">
                  <Icon type="check" />
                  {translationsStore.translate(
                    "carView.MaintenanceCard.confirm.title",
                  )}
                </div>
              </Menu.Item>
              {record.custom && (
                <Menu.Item key="update">
                  <div className="MaintenanceCard__additionalcta_content">
                    <Icon type="edit" />
                    {translationsStore.translate(
                      "carView.MaintenanceCard.update",
                    )}
                  </div>
                </Menu.Item>
              )}
              <Menu.Item key="delete">
                <div className="MaintenanceCard__additionalcta_content">
                  <Icon type="delete" />
                  {translationsStore.translate(
                    "carView.MaintenanceCard.delete.label",
                  )}
                </div>
              </Menu.Item>
            </Menu>
          );
          return (
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button
                className="ant-dropdown-link maintenance-card-dropdown"
                type="ghost"
              >
                <Icon type="more"/>
              </Button>
            </Dropdown>
          );
        }
      }
    ];
    const cardColumnWidths = [null, '12%', '15%', '12%', '12%', '13%', '11%'];
    this.cardColumns = this.columns.map((column, index) => {
      if(index === 0) {
        return column;
      }
      if(index === this.columns.length - 1) {
        return {
          ...column,
          className: 'maintenance-action',
          width: cardColumnWidths[index]
        };
      }
      return  {
            ...column,
            className: 'maintenance-card-compact-column',
            width: cardColumnWidths[index]
          };
    });
    const dialogColumnWidths = [null, 100, 110, 90, 90, 90, 80];
    this.dialogColumns = this.columns.map((column, index) => ({
      ...column,
      title: <div className="maintenance-dialog-cell" title={column.title}>{column.title}</div>,
      render: (...params) => (
        <div className="maintenance-dialog-cell" title={index === 0 ? params[0] : undefined}>
          {index === 0 ? params[0] : column.render ? column.render(...params) : params[0]}
        </div>
      ),
      ...(dialogColumnWidths[index] ? { width: dialogColumnWidths[index] } : {})
    }));

    this.historyTableColumns = [
      {
        dataIndex: 'description',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.type'),
        sorter: true,
        sortOrder: false,
      },
      {
        dataIndex: 'date',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.scheduledDate'),
        sorter: true,
        sortOrder: false,
        width: 120,
        align: 'center',
        render: text => text ? moment(text).format(commonStore.longDateFormat.L) : '-'
      },
      {
        dataIndex: 'km',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.scheduledKm'),
        sorter: true,
        sortOrder: false,
        width: 80,
        align: 'center',
        render: text => text ? Number(text).toLocaleString() : '-'
      },
      {
        dataIndex: 'updatedAt',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.closedDate'),
        sorter: true,
        sortOrder: false,
        width: 120,
        render: text => `${moment(text).format(commonStore.longDateFormat.L)} ${moment(text).format(commonStore.longDateFormat.LT)}`
      }
    ];
    this.historyFetchMethods = [
      {
        key: 'maintenances',
        method: 'getMaintenancesCarHistory',
        defaultSorter: { field: 'updatedAt', order: 'DESC' }
      }
    ];

    this.defaultAddValues = {
      description: '',
      km: '',
      moment: null,
      date: ''
    };

    this.state = {
      sorters: { maintenances: this.historyFetchMethods[0].defaultSorter },
      showModalUpsert: false,
      showModalUpsertInManage: false,
      modalAddLoading: false,
      modalCanAdd: false,
      modalAddDescription: this.defaultAddValues.description,
      modalAddKm: this.defaultAddValues.km,
      modalAddMoment: this.defaultAddValues.moment,
      modalAddDate: this.defaultAddValues.date,
      selectedMaintenance: null,
      showConfirmDelete: false,
    };
  }

  loadHistory = (methods = ['maintenances'], page = 1) => {
    this.setState({
      historyLoading: true
    });
    const { carId } = this.props;
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };

  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };

  confirmManage = () => {
    this.setState({ modalAddLoading: true });
    api('confirmMaintenances', this.state.selectedMaintenance)
      .then(maintenanceSummary => {
        if (this.state.checkedNewMaintenance) {
          this.setState({ showModalUpsertInManage: true });
        }
        this.props.onConfirmMaintenances();
        this.setState({ maintenanceSummary, showManageModal: false, selectedMaintenance: null });
      })
      .catch(() => {
        this.setState({ showManageModal: false, selectedMaintenance: null, showModalUpsertInManage: false });
      })
      .finally(() => {
        this.setState({ modalAddLoading: false});
      });
  };

  resetModal = () => {
    this.setState({
      modalAddLoading: false,
      modalCanAdd: true,
      modalAddDescription: null,
      modalAddKm: null,
      modalAddMoment: null,
      modalAddDate: null
    });
  };

  onChange = () => {
    this.setState({
      checkedNewMaintenance: this.state.checkedNewMaintenance ? false : true
    });
  };

  render() {
    const { translationsStore } = this.props;
    const { sorters, historyActiveKey } = this.state;
    const columns = this.historyTableColumns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {   
        ...column,
        sortOrder
      };
    });
    return (
      <Card className="MaintenanceCard" style={this.props.style} id="MaintenanceCard">

        <div className="header">
          <div style={{ display: 'flex', flexGrow: 1, alignItems: 'center' }}>
              <div>{translationsStore.translate('carView.MaintenanceCard.title')}</div>
              <div style={{ marginLeft: 20 }}>
                <UpsertMaintenanceModal
                  carId={this.props.carId}
                  visible={this.state.showModalUpsert}
                  onCancel={() => this.setState({ showModalUpsert: false })}
                  onOk={() => {
                    this.setState({ showModalUpsert: false });
                    this.props.onConfirmMaintenances();
                  }}
                />
                <Button
                  onClick={() => {
                    this.setState({ showModalUpsert: true });
                  }}
                  type="primary"
                >
                  {translationsStore.translate('carView.MaintenanceCard.createNew.labelCreate')}
                </Button>
              </div>
            <div style={{ flexGrow: 1 }}/>
            <Popover
              content={translationsStore.translate('carView.MaintenanceCard.historyNoData.message')}
              title={translationsStore.translate('carView.MaintenanceCard.historyNoData.title')}
              trigger="click"
              visible={this.state.historySum === 0 && this.state.historyNoDataHint}
              onVisibleChange={visible => this.setState({ historyNoDataHint: visible })}
            >
              <Button onClick={() => this.loadHistory()} type="primary">
                {translationsStore.translate('carView.history')}
              </Button>
            </Popover>
          </div>
        </div>
        <Table
          className="maintenance-card-table"
          pagination={false}
          dataSource={this.props.maintenances}
          columns={this.cardColumns}
          rowKey={record => record.id}
        />
        {!!this.props.othermaintenances && this.props.othermaintenances.length > 0 && (
          <div onClick={() => this.setState({ showothers: true })} style={{ marginTop: '10px', cursor: 'pointer', textDecoration: 'underline', fontWeight: 'bold' }}>
            {this.props.othermaintenances.length} {translationsStore.translate('carView.MaintenanceCard.othermaintenances.message')}
          </div>
        )}
        <Modal
          title={translationsStore.translate('carView.MaintenanceCard.othermaintenances.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.showothers}
          getContainer={() => document.getElementById('MaintenanceCard')}
          footer={null}
          onCancel={() => this.setState({ showothers: false })}
          centered={true}
        >
          <Table
            className="maintenance-dialog-table"
            pagination={false}
            columns={this.dialogColumns}
            dataSource={this.props.othermaintenances}
            rowKey={record => record.id}
          />
        </Modal>
        <Modal
          title={translationsStore.translate('carView.MaintenanceCard.history.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.historyShow}
          getContainer={() => document.getElementById('MaintenanceCard')}
          footer={null}
          onCancel={() => this.setState({ historyShow: false })}
          centered={true}
        >
          <Spin spinning={this.state.historyLoading}>
            {(this.state.historyResources || []).map(
              (item, index) =>
                item.count > 0 &&
                item.key === this.state.historyActiveKey && (
                  <Table
                    id="MaintenanceCardHistory"
                    key={index}
                    dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
                    columns={columns}
                    pagination={item.pagination}
                    onChange={(...params) => this.handleTableChange(item.key, ...params)}
                    rowClassName="historyRow"
                  />
                )
            )}
          </Spin>
        </Modal>
        <Modal
          title={translationsStore.translate('carView.MaintenanceCard.confirm.title')}
          visible={this.state.showManageModal}
          onCancel={() => this.setState({ showManageModal: false, checkedNewMaintenance: false, selectedMaintenance: null })}
          onOk={this.confirmManage}
          confirmLoading={this.state.modalAddLoading}
        >
          <div>
            {translationsStore.translate("carView.MaintenanceCard.confirm.confirmationMessage")}
          </div>
          <Checkbox onChange={this.onChange} checked={this.state.checkedNewMaintenance}>
            {translationsStore.translate('carView.MaintenanceCard.confirm.labelCreateAnotherOne')}
          </Checkbox>
        </Modal>
        <UpsertMaintenanceModal
          carId={this.props.carId}
          visible={this.state.showModalUpsertInManage}
          maintenance={this.state.selectedMaintenance}
          onCancel={() => this.setState({ showModalUpsertInManage: false, checkedNewMaintenance: false, selectedMaintenance: null })}
          onOk={() => {
            this.setState({ showModalUpsertInManage: false, checkedNewMaintenance: false, selectedMaintenance: null });
            this.props.onConfirmMaintenances();
          }}
        />
        {this.state.showConfirmDelete && (
          <ConfirmDeleteMaintenanceModal
            visible={this.state.showConfirmDelete}
            maintenance={this.state.selectedMaintenance}
            onCancel={() => this.setState({ showConfirmDelete: false, selectedMaintenance: null })}
            onDone={() => {
              this.setState({ showConfirmDelete: false, selectedMaintenance: null });
              this.props.onConfirmMaintenances();
            }}
          />
        )}
      </Card>
    );
  }
}

@inject("translationsStore")
@observer
class ConfirmDeleteMaintenanceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
  }

  handleOk = async () => {
    this.setState({ loading: true });
    try {
      await api("deleteMaintenance", this.props.maintenance.id);
      this.props.onDone();
    } catch (error) {
      console.error(`Error deleting maintenance: ${error}`);
      // Optionally, you could show an error message to the user here.
      this.setState({ loading: false });
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  }

  render() {
    const { visible, translationsStore } = this.props;
    const { loading } = this.state;
    return (
      <Modal
        visible={visible}
        title={translationsStore.translate("carView.MaintenanceCard.delete.confirmation.title")}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        okText={translationsStore.translate("carView.MaintenanceCard.delete.label")}
        okType="danger"
        confirmLoading={loading}
        cancelButtonProps={{ disabled: loading }}
        destroyOnClose
      >
        <div>
          {translationsStore.translate("carView.MaintenanceCard.delete.confirmation.content").replace("__MAINTENANCE__", this.props.maintenance.description)}
        </div>
      </Modal>
    );
  }
}
